var _mask, _g, _path, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "telephone_svg__a",
    width: 29,
    height: 19,
    x: 4,
    y: 15,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.352 15h27.92v18.348H4.352z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#telephone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M32.272 33.348H7.849a3.496 3.496 0 0 1-3.448-4.073L6.789 15h23.303l2.18 13.015z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M13.927 21.333H12.6a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M18.975 21.333H17.65a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.326a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M24.024 21.333h-1.327a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M13.927 25.437H12.6a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M18.975 25.437H17.65a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.326a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M24.024 25.437h-1.327a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M13.927 29.542H12.6a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M18.975 29.542H17.65a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.326a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6M24.024 29.542h-1.327a.6.6 0 0 1-.6-.6v-1.326a.6.6 0 0 1 .6-.6h1.327a.6.6 0 0 1 .6.6v1.326a.6.6 0 0 1-.6.6",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "telephone_svg__b",
    width: 31,
    height: 11,
    x: 3,
    y: 3,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 3h30.623v10.192H3z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#telephone_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D23",
    fillRule: "evenodd",
    d: "M25.506 13.192h7.017a1.1 1.1 0 0 0 1.1-1.1V7.16c0-1.403-1.234-2.179-2.54-2.54S24.004 3 18.313 3C12.618 3 6.845 4.258 5.54 4.62 4.235 4.98 3 5.756 3 7.16v4.931c0 .608.492 1.101 1.101 1.101h7.016v-2.117a2.54 2.54 0 0 1 2.54-2.54h9.31a2.54 2.54 0 0 1 2.54 2.54z",
    clipRule: "evenodd"
  }))));
};
export default SvgTelephone;